(()=>{
if(window.pmPrintReady)return;window.pmPrintReady=true;
const S={mode:'standalone',target:null,form:null,wrap:null};
const q=(s,r=document)=>r.querySelector(s),qa=(s,r=document)=>[...r.querySelectorAll(s)];
function formFor(el){const sec=el?.closest?.('.product-section');return q('form[action*="/cart/add"]',sec)||q('.product-section:not([data-modal="true"]) form[action*="/cart/add"]')||q('form[action*="/cart/add"]')}
function wrapFor(form){const sec=form?.closest?.('.product-section');return q('.pampas-addons',sec)||q('.pampas-addons')}
function mark(form,on){form?.closest?.('.product-section')?.classList.toggle('pm-has-personalization',!!on)}
function clearPrint(form){qa('[data-pm-print]',form).forEach(x=>x.remove());delete form.dataset.pmPrintReady;delete form.dataset.pmPrintMode}
function hidden(form,name,value){const i=document.createElement('input');i.type='hidden';i.name=name;i.value=value;i.dataset.pmPrint='1';form.append(i)}
function fileInput(form,file,name='properties[קובץ PDF מוכן להדפסה]',unitIndex=null){if(typeof DataTransfer!=='function')throw Error('הדפדפן אינו תומך בצירוף הקובץ');const d=new DataTransfer();d.items.add(file);const i=document.createElement('input');i.type='file';i.name=name;i.hidden=true;i.dataset.pmPrint='1';if(unitIndex!==null)i.dataset.pmUnitPrint=String(unitIndex);i.files=d.files;form.enctype='multipart/form-data';form.append(i)}
async function canvas(form){
  /* REQ-010 P4/P5: the main design prints from the shared renderer (same model as the page mockup and the editor),
     one scale factor, every element. */
  /* S11: a sticker add-on (or one of its units) designed in the new editor prints from its own model */
  if(window.PMSticker&&S.target&&S.target._pmEdModel){return window.PMSticker.toCanvas(S.target._pmEdModel)}
  if(window.PMSticker&&window.PMStickerModel&&!S.target){return window.PMSticker.toCanvas(window.PMStickerModel)}
  /* REQ-019 S2: the old designer's stage (#pmStage), measured as a last resort, is gone. Without the renderer the add path keeps the
     line with its wording and template and the studio prepares the file (printFallback, REQ-004). */
  throw Error('לא נמצאה תצוגת העיצוב');
}
function pdf(c){const bin=atob(c.toDataURL('image/jpeg',.96).split(',')[1]),jpg=Uint8Array.from(bin,ch=>ch.charCodeAt(0)),enc=new TextEncoder(),parts=[],off=[0];let len=0;const txt=s=>{const b=enc.encode(s);parts.push(b);len+=b.length},bytes=b=>{parts.push(b);len+=b.length},obj=n=>{off[n]=len;txt(n+' 0 obj\n')},end=()=>txt('endobj\n');txt('%PDF-1.4\n%PAMPAS\n');obj(1);txt('<< /Type /Catalog /Pages 2 0 R >>\n');end();obj(2);txt('<< /Type /Pages /Kids [3 0 R] /Count 1 >>\n');end();obj(3);txt('<< /Type /Page /Parent 2 0 R /MediaBox [0 0 297.64 419.53] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>\n');end();obj(4);txt(`<< /Type /XObject /Subtype /Image /Width ${c.width} /Height ${c.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpg.length} >>\nstream\n`);bytes(jpg);txt('\nendstream\n');end();const content='q\n297.64 0 0 419.53 0 0 cm\n/Im0 Do\nQ\n',cb=enc.encode(content);obj(5);txt(`<< /Length ${cb.length} >>\nstream\n`);bytes(cb);txt('endstream\n');end();const xr=len;txt('xref\n0 6\n0000000000 65535 f \n');for(let n=1;n<=5;n++)txt(String(off[n]).padStart(10,'0')+' 00000 n \n');txt(`trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n${xr}\n%%EOF`);return new Blob(parts,{type:'application/pdf'})}
function busy(form,on){const b=q('[data-add-to-cart]',form);if(!b)return;const l=q('[data-add-to-cart-text]',b)||b;if(on){b.dataset.pmOld=l.textContent;b.disabled=true;l.textContent='מכינים את קובץ ההדפסה...'}else{if(b.dataset.pmOld)l.textContent=b.dataset.pmOld;b.disabled=false}}
async function generate(form){clearPrint(form);busy(form,true);try{const c=await canvas(form),blob=pdf(c),f=new File([blob],'כרטיס-ברכה-A6-מוכן-להדפסה.pdf',{type:'application/pdf'});fileInput(form,f);hidden(form,'properties[פורמט הדפסה]','A6, 300 DPI, PDF');hidden(form,'properties[מידות קובץ]','1240×1748 פיקסלים');form.dataset.pmPrintReady='1';form.dataset.pmPrintMode=S.mode;mark(form,true);return f}finally{busy(form,false)}}
async function generateUnit(form,target){
  const index=parseInt(target.dataset.pmItemIndex||'0',10)||0;
  const c=await canvas(form),blob=pdf(c);
  const file=new File([blob],`הקדשה-למוצר-${index+1}-A6.pdf`,{type:'application/pdf'});
  target._pmDesignFile=file;target.dataset.pmDesigned='1';
  syncUnitPrintFiles(form,designPanelFor(form));
  form.dataset.pmPrintReady='1';form.dataset.pmPrintMode='standalone-different';mark(form,true);
  updateItemDesignStatus(target);
  return file;
}
document.addEventListener('pampas:open-personalization',e=>{const d=e.detail||{};S.mode=d.mode||'standalone';S.target=d.target||null;S.wrap=S.target?.closest?.('.pampas-addons')||q('.pampas-addons');S.form=formFor(S.wrap||S.target)},true);
function init(w){if(!w||w.dataset.pmInit)return;w.dataset.pmInit='1';w.addEventListener('change',e=>{const c=e.target.closest('input[data-addon-variant]');if(!c)return;const t=q(`textarea[data-for="${c.dataset.addonVariant}"]`,w),f=formFor(w);if(t){t.hidden=true;if(!c.checked)t.value=''}if(c.checked&&c.dataset.personalizationMode){S.mode=c.dataset.personalizationMode;S.target=t;S.wrap=w;S.form=f;document.dispatchEvent(new CustomEvent('pampas:open-personalization',{detail:{mode:S.mode,target:t}}))}const has=!!q('input[data-personalization-mode]:checked',w);mark(f,has||!!f?.dataset.pmPrintReady);if(!has&&f?.dataset.pmPrintMode!=='standalone'){qa('[data-ded]',f).forEach(x=>x.remove());clearPrint(f);window.PMDedication?.clearApproved()}})}
function designPanelFor(form){const sec=form?.closest?.('.product-section');return sec?q('[data-pm-design-pricing]',sec):q('[data-pm-design-pricing]')}
function normalizeDesign(value){return String(value||'').normalize('NFC').replace(/\s+/g,' ').trim()}
function designMode(panel){return q('[data-pm-design-mode]:checked',panel)?.value||'same'}
function itemQuantity(form){
  const section=form?.closest?.('.product-section');
  const input=q('[name="quantity"]',form)||q('[name="quantity"]',section)||q('.product-section:not([data-modal="true"]) [name="quantity"]')||q('[name="quantity"]');
  return Math.max(1,parseInt(input?.value||'1',10)||1);
}
function updateItemDesignStatus(textarea){
  const field=textarea?.closest?.('.pm-item-design'),button=q('[data-pm-design-item-button]',field),status=q('[data-pm-design-item-status]',field);
  const approved=!!textarea?._pmDesignFile;
  if(button){button.classList.toggle('is-approved',approved);button.innerHTML=approved?'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg> עוצב · עריכה':'עיצוב ההקדשה';}
  if(status)status.textContent=approved?'העיצוב אושר וקובץ ההדפסה מוכן.':'יש לפתוח ולאשר את העיצוב.';
}
/* per-design print format and size beside its file, named as the sticker add-on lines name them (removed with the unit files on re-sync) */
function unitPrintMeta(form,tag,unitIndex){[['פורמט הדפסה','A6, 300 DPI, PDF'],['מידות קובץ','1240×1748 פיקסלים']].forEach(([k,v])=>{hidden(form,'properties['+k+tag+']',v);const i=form.lastElementChild;i.dataset.pmUnitPrint=String(unitIndex)})}
function syncUnitPrintFiles(form,panel){
  qa('[data-pm-unit-print]',form).forEach(input=>input.remove());
  if(!panel||designMode(panel)!=='different')return;
  const groups=new Map();
  qa('[data-pm-item-design]',panel).forEach((textarea,index)=>{
    if(!textarea._pmDesignFile)return;
    /* designs manager: candles of one design share its file, sent once */
    const g=textarea._pmDesignGroup;
    if(g){if(groups.has(g))return;groups.set(g,groups.size+1);fileInput(form,textarea._pmDesignFile,`properties[קובץ PDF לעיצוב ${groups.size}]`,index);unitPrintMeta(form,' — עיצוב '+groups.size,index);return;}
    fileInput(form,textarea._pmDesignFile,`properties[קובץ PDF למוצר ${index+1}]`,index);unitPrintMeta(form,' — מוצר '+(index+1),index);
  });
}
function ensureItemDesignFields(panel){
  const form=formFor(panel),container=q('[data-pm-item-designs]',panel),mode=designMode(panel);
  if(!container||!form)return;
  if(mode==='same'){container.hidden=true;syncUnitPrintFiles(form,panel);return;}
  container.hidden=false;
  const quantity=itemQuantity(form),currentFields=qa('.pm-item-design',container);
  const primary=String(q('input[name="properties[טקסט הקדשה]"]',form)?.value||'').trim();
  if(currentFields.length===quantity){
    const first=q('[data-pm-item-design]',container);
    if(first&&!first.value.trim()&&primary)first.value=primary;
    qa('[data-pm-item-design]',container).forEach(updateItemDesignStatus);
    return;
  }
  container.replaceChildren();
  for(let index=0;index<quantity;index++){
    let field=currentFields[index];
    if(!field){
      const label=document.createElement('label'),textarea=document.createElement('textarea'),actions=document.createElement('div'),button=document.createElement('button'),status=document.createElement('span');
      field=document.createElement('div');field.className='pm-item-design';
      textarea.dataset.pmItemDesign='1';textarea.maxLength=300;
      actions.className='pm-item-design__actions';button.type='button';button.className='pm-item-design__button';button.dataset.pmDesignItemButton='1';status.className='pm-item-design__status';status.dataset.pmDesignItemStatus='1';
      actions.append(button,status);field.append(label,textarea,actions);
    }
    const label=q('label',field),textarea=q('[data-pm-item-design]',field);
    label.textContent=`הקדשה למוצר ${index+1}`;textarea.dataset.pmItemIndex=String(index);
    textarea.placeholder=`כתבו את הנוסח למוצר ${index+1}`;
    if(!textarea.value&&index===0&&primary)textarea.value=primary;
    container.append(field);updateItemDesignStatus(textarea);
  }
  syncUnitPrintFiles(form,panel);
}
function designInfo(form){
  const panel=designPanelFor(form);
  if(!panel)return{panel:null,mode:'same',assignments:[],missing:[],undesigned:[],entries:[],extraCount:0,totalDesigns:1,quantity:1,priceCents:0,variantId:0,included:false,required:false};
  const mode=designMode(panel),quantity=itemQuantity(form);
  const included=panel.dataset.pmDesignIncluded==='true';
  const required=panel.dataset.pmDesignRequired==='true';
  if(mode==='different')ensureItemDesignFields(panel);
  const primary=String(q('input[name="properties[טקסט הקדשה]"]',form)?.value||'').trim();
  const assignments=mode==='different'
    ?qa('[data-pm-item-design]',panel).slice(0,quantity).map(input=>String(input.value||'').trim())
    :[primary];
  const missing=mode==='different'?assignments.map((value,index)=>value?0:index+1).filter(Boolean):[];
  const undesigned=mode==='different'?qa('[data-pm-item-design]',panel).slice(0,quantity).map((input,index)=>input._pmDesignFile?0:index+1).filter(Boolean):[];
  const seen=new Set(),entries=[];
  /* Ran 20.10 designs manager: a design (group) counts once, so the charge is per design card, whatever its text */
  const units=mode==='different'?qa('[data-pm-item-design]',panel).slice(0,quantity):[];
  assignments.forEach((value,index)=>{
    const g=units[index]?._pmDesignGroup,clean=g?'g:'+g:normalizeDesign(value);
    if(!clean||seen.has(clean))return;
    seen.add(clean);entries.push(value.trim());
  });
  return{
    panel,
    mode,
    assignments,
    missing,
    undesigned,
    entries,
    extraCount:Math.max(0,entries.length-1),
    totalDesigns:Math.max(1,entries.length),
    quantity,
    priceCents:included?0:(parseInt(panel.dataset.addonPriceCents||'0',10)||0),
    variantId:included?0:(parseInt(panel.dataset.addonVariant||'0',10)||0),
    included,
    required
  };
}
function assignList(info){
  if(window.PMDesigns&&window.PMDesigns.active())return window.PMDesigns.summary();
  return info.assignments.map((value,index)=>`${index+1}. ${normalizeDesign(value)}`).join(' | ');
}
function money(cents){const value=cents/100;return`${Number.isInteger(value)?value:value.toFixed(2)} ₪`}
function updateDesignSummary(panel){
  ensureItemDesignFields(panel);
  const form=formFor(panel),info=designInfo(form),summary=q('[data-pm-design-summary]',panel);
  if(!summary)return;
  if(info.mode==='same'){
    summary.style.removeProperty('color');
    summary.textContent=info.included
      ?`אותה הקדשה לכל ${info.quantity} המוצרים — כלול במחיר`
      :`אותה הקדשה לכל ${info.quantity} המוצרים — ללא תוספת תשלום`;
    return;
  }
  if(info.missing.length){
    summary.textContent=`חסר נוסח עבור ${info.missing.length} מתוך ${info.quantity} המוצרים.`;
    summary.style.color='#9b2c2c';
    return;
  }
  if(info.undesigned.length){
    summary.textContent=`נשאר לעצב ולאשר ${info.undesigned.length} מתוך ${info.quantity} ההקדשות.`;
    summary.style.color='#9b2c2c';
    return;
  }
  summary.style.removeProperty('color');
  summary.textContent=info.included
    ?`${info.totalDesigns} עיצובים עבור ${info.quantity} מוצרים — הכל כלול במחיר`
    :info.extraCount
    ?`${info.totalDesigns} עיצובים שונים — תוספת ${window.PMMoney?window.PMMoney(info.extraCount*info.priceCents):money(info.extraCount*info.priceCents)}`
    :`כל ${info.quantity} הנוסחים זהים — ללא תוספת תשלום`;
}
function initDesignPricing(panel){
  if(!panel||panel.dataset.pmDesignInit)return;
  panel.dataset.pmDesignInit='1';
  if(panel.dataset.pmDesignRequired==='true')mark(formFor(panel),true);
  panel.addEventListener('click',event=>{
    const button=event.target.closest?.('[data-pm-design-item-button]');if(!button)return;
    const textarea=q('[data-pm-item-design]',button.closest('.pm-item-design'));if(!textarea)return;
    S.mode='standalone';S.target=textarea;S.wrap=null;S.form=formFor(panel);
    document.dispatchEvent(new CustomEvent('pampas:open-personalization',{detail:{mode:'standalone',target:textarea,unitIndex:parseInt(textarea.dataset.pmItemIndex||'0',10)||0}}));
  });
  panel.addEventListener('change',event=>{
    if(!event.target.matches?.('[data-pm-design-mode]'))return;
    ensureItemDesignFields(panel);updateDesignSummary(panel);
  });
  panel.addEventListener('input',event=>{
    if(event.target.matches?.('[data-pm-item-design]')){
      delete event.target._pmDesignFile;delete event.target.dataset.pmDesigned;
      /* Ran 20.10 (bug): typed text replaces the saved sticker model, so the print never shows the older wording */
      if(event.isTrusted){delete event.target._pmDesignerState;delete event.target._pmEdModel;}
      updateItemDesignStatus(event.target);syncUnitPrintFiles(formFor(panel),panel);updateDesignSummary(panel);
    }
  });
  ensureItemDesignFields(panel);
  updateDesignSummary(panel);
}
function designHidden(form,name,value){
  const input=document.createElement('input');
  input.type='hidden';input.name=name;input.value=value;input.dataset.pmDesignProperty='1';form.append(input);
}
function setDesignProperties(form,info){
  qa('[data-pm-design-property]',form).forEach(input=>input.remove());
  if(!info.panel)return;
  designHidden(form,'properties[אופן חלוקת ההקדשות]',info.mode==='same'?`אותה הקדשה לכל ${info.quantity} המוצרים`:'הקדשה נפרדת לכל מוצר');
  designHidden(form,'properties[מספר עיצובים שונים]',String(info.totalDesigns));
  if(info.mode==='different'){
    /* unit approvals no longer write the main wording; the line shows unit 1's when the main design was never approved */
    if(!String(q('input[name="properties[טקסט הקדשה]"]',form)?.value||'').trim()&&info.assignments[0])designHidden(form,'properties[טקסט הקדשה]',info.assignments[0]);
    designHidden(form,'properties[נוסחים לפי מוצר]',assignList(info));
  }
  if(info.extraCount&&!info.included&&info.priceCents>0){
    designHidden(form,'properties[חיוב עיצובים נוספים]',`${info.extraCount} × ${money(info.priceCents)}`);
  }
}
/* for assets/pampas-designs.js (Ran 20.10): a print file from a design model, and a resync of the per-candle fields */
window.PMPrint={
  file:async(model,name)=>{const c=await window.PMSticker.toCanvas(model);return new File([pdf(c)],name,{type:'application/pdf'})},
  panel:designPanelFor,
  quantity:itemQuantity,
  sync:form=>{const panel=designPanelFor(form);if(!panel)return;ensureItemDesignFields(panel);syncUnitPrintFiles(form,panel);updateDesignSummary(panel);if(designMode(panel)==='different'||q('[data-pm-unit-print]',form))mark(form,true)}
};
qa('.pampas-addons').forEach(init);
qa('[data-pm-design-pricing]').forEach(initDesignPricing);
new MutationObserver(ms=>ms.forEach(m=>m.addedNodes.forEach(n=>{
  if(n.nodeType!==1)return;
  if(n.matches?.('.pampas-addons'))init(n);
  if(n.matches?.('[data-pm-design-pricing]'))initDesignPricing(n);
  qa('.pampas-addons',n).forEach(init);
  qa('[data-pm-design-pricing]',n).forEach(initDesignPricing);
}))).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('input',e=>{
  if(!e.target.matches?.('[name="quantity"]'))return;
  const form=e.target.closest?.('form[action*="/cart/add"]'),panel=designPanelFor(form);
  if(panel){ensureItemDesignFields(panel);updateDesignSummary(panel);}
});
/* an approval in the editor (REQ-019 S2: PMDedication's 'pm:design-approved'; it was a click on the old designer's hidden #pmApprove) */
document.addEventListener('pm:design-approved',e=>{
  const approvedTarget=(e.detail&&e.detail.target)||S.target;
  setTimeout(()=>{
    const f=S.form||formFor(approvedTarget);
    const isUnit=approvedTarget?.matches?.('[data-pm-item-design]');
    if(isUnit?!approvedTarget.value.trim():!q('input[name="properties[טקסט הקדשה]"]',f)?.value?.trim())return;
    const panel=designPanelFor(f);
    const task=isUnit?generateUnit(f,approvedTarget):generate(f);
    f._pmPrintPromise=task.then(file=>{if(panel){ensureItemDesignFields(panel);updateDesignSummary(panel)}return file}).catch(err=>{console.error(err);if(!isUnit)clearPrint(f);atcMessage(f,'לא הצלחנו להכין את קובץ ההדפסה. נסו שוב.');throw err});
  },0);
});
/* REQ-004: errors next to the Add to Cart button, never alert(). */
function atcMessage(form,msg){
  if(!form)return;
  let p=q('[data-pm-atc-error]',form);
  if(!msg){p?.remove();return}
  if(!p){
    p=document.createElement('p');p.dataset.pmAtcError='1';p.setAttribute('role','alert');
    p.style.cssText='margin:8px 0 0;font-size:14px;font-weight:700;line-height:1.4;color:#9b2c2c;text-align:center';
    const b=q('[data-add-to-cart]',form);
    if(b&&b.parentNode)b.insertAdjacentElement('afterend',p);else form.append(p);
  }
  p.textContent=msg;
}
window.pmInlineError=atcMessage;
/* REQ-004: the add never fails because the browser could not build the PDF. The line keeps the wording and template; the studio prepares the file. */
function printFallback(form,key){
  qa(`[data-pm-print-fallback="${key}"]`,form).forEach(x=>x.remove());
  const i=document.createElement('input');i.type='hidden';
  i.name=key==='main'?'properties[קובץ הדפסה]':`properties[קובץ הדפסה למוצר ${key}]`;
  i.value='יוכן בסטודיו לפי הנוסח והתבנית';i.dataset.pmPrintFallback=key;form.append(i);
}
/* REQ-004: Add to Cart approves the design the page shows (default template, or the customer's edits). */
async function approveShownDesign(form,w){
  const d=window.PMDedication;
  const m=(w&&q('input[data-personalization-mode]:checked',w))?.dataset.personalizationMode||'standalone';
  if(!q('input[name="properties[טקסט הקדשה]"]',form)&&!(d&&d.approveShown(m)))return false;
  S.mode=m;
  try{await generate(form)}catch(err){console.error(err);clearPrint(form);printFallback(form,'main')}
  return true;
}
async function approveMissingUnits(form,panel){
  const d=window.PMDedication,used=[];
  for(const t of qa('[data-pm-item-design]',panel).slice(0,itemQuantity(form))){
    if(t._pmDesignFile)continue;
    const index=(parseInt(t.dataset.pmItemIndex||'0',10)||0)+1;
    if(!d||!d.approveUnit(t))continue;
    /* Codex G3 recheck (P1): print THIS unit's wording. Without a target the canvas fell back to the main design for every unit.
       A unit never opened in the editor prints the main design's look (font, sizes, icon) with its own text. */
    const own=!!t._pmEdModel,prevT=S.target,prevM=S.mode;S.target=t;S.mode='standalone';
    if(!own&&window.PMStickerModel){const m=JSON.parse(JSON.stringify(window.PMStickerModel));m.body=t.value.trim();m.bodyOff=false;m.heading='';m.tpl='free';t._pmEdModel=m}
    try{await generateUnit(form,t)}catch(err){console.error(err);printFallback(form,String(index))}
    finally{if(!own)delete t._pmEdModel;S.target=prevT;S.mode=prevM}
    used.push(index);
  }
  form._pmShownUnits=used;
}
document.addEventListener('submit',async e=>{
  const f=e.target.closest?.('form[action*="/cart/add"]');
  if(!f||f.dataset.pmNative==='1')return;
  const w=wrapFor(f),checked=w?qa('input[data-addon-variant]:checked',w):[];
  const initialDesign=designInfo(f),hasFile=!!q('[data-pm-print][type="file"]',f);
  const needs=!!(w&&q('input[data-personalization-mode="sticker"]:checked',w))||f.dataset.pmPrintMode==='standalone'||!!initialDesign.panel;
  if(!checked.length&&!hasFile&&!f._pmPrintPromise&&!initialDesign.panel)return;
  e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
  if(f.dataset.pmProcessing==='1')return;
  f.dataset.pmProcessing='1';
  const b=e.submitter||q('[data-add-to-cart]',f);
  if(b)b.disabled=true;
  atcMessage(f,'');
  try{
    if(f._pmPrintPromise)await f._pmPrintPromise.catch(()=>null);
    let design=designInfo(f);
    if(design.panel&&design.mode==='different'){
      if(window.PMDesigns&&window.PMDesigns.active())await window.PMDesigns.beforeAdd(f);
      await approveMissingUnits(f,design.panel);
      design=designInfo(f);
      syncUnitPrintFiles(f,design.panel);
    }else if(needs&&!q('[data-pm-print][type="file"]:not([data-pm-unit-print])',f)&&!q('[data-pm-print-fallback]',f)){
      /* REQ-019 adversarial review (high): without PMDedication (its script failed to load) nothing writes the dedication; the add stops
         with a message instead of putting the product in the cart without its design */
      if(!(await approveShownDesign(f,w)))throw Error('לא הצלחנו להכין את ההקדשה. רעננו את העמוד ונסו שוב.');
      design=designInfo(f);
    }
    const pv=q('[name="id"]',f)?.value||'',handle=f.closest('.product-section')?.dataset.productHandle||'';
    let items=null,pmPerAddon=false;
    if(typeof window.pmAddonItems==='function'&&w){
      const built=window.pmAddonItems(f,w,handle,pv);
      if(built&&built.length){items=built;pmPerAddon=true}
    }
    if(!pmPerAddon){
      items=checked.map(c=>{
        const p={_linked_to:handle,_parent_variant:pv},t=q(`textarea[data-for="${c.dataset.addonVariant}"]`,w);
        if(t?.value)p['טקסט']=t.value;
        if(c.dataset.personalizationMode)p['סוג עיצוב']=c.dataset.personalizationMode==='greeting'?'ברכה':'מדבקת הקדשה';
        return{id:parseInt(c.dataset.addonVariant,10),quantity:1,properties:p};
      });
      if(design.extraCount&&!design.included&&design.priceCents>0){
        if(!design.variantId)throw Error('לא ניתן לחשב את תוספת העיצובים.');
        items.push({
          id:design.variantId,
          quantity:design.extraCount,
          properties:{
            _linked_to:handle,
            _parent_variant:pv,
            /* review fix R4 (21.10): marked like every other path that adds this charge (sections/pampas-design-pricing-fix.liquid,
               assets/pampas-cart-edit.js), so the cart shows it fixed and cart edit finds and replaces it */
            _pm_distinct_design_charge:'1',
            'מספר עיצובים נוספים':String(design.extraCount),
            'נוסחים לפי מוצר':assignList(design)
          }
        });
      }
    }
    /* review fix F3 (21.10): one design for the whole quantity always carries אופן חלוקת ההקדשות and מספר עיצובים שונים, ticked
       add-ons or not, as quick design and cart edit write them; a different design per unit keeps the properties of its path */
    setDesignProperties(f,pmPerAddon&&design.mode==='different'?{panel:null}:design);
    /* Ran 20.10 (bug): unit approvals no longer write the main wording, so a per-unit line carries unit 1's text and the full list itself (the cart's gift line reads them) */
    if(pmPerAddon&&design.panel&&design.mode==='different'){
      if(!String(q('input[name="properties[טקסט הקדשה]"]',f)?.value||'').trim()&&design.assignments[0])designHidden(f,'properties[טקסט הקדשה]',design.assignments[0]);
      let u1=q('[data-pm-item-design]',design.panel)?._pmEdModel;
      if(!u1&&window.PMStickerModel){u1=JSON.parse(JSON.stringify(window.PMStickerModel));u1.body=design.assignments[0]||'';u1.heading='';u1.tpl='free'}
      if(u1&&!q('input[name="properties[_עיצוב]"]',f)){try{designHidden(f,'properties[_עיצוב]',JSON.stringify(u1,(k,v)=>(k==='logo'||k==='src')&&typeof v==='string'&&v.length>200?'[תמונה מצורפת]':v))}catch(err){}}
      /* the designs manager writes its own "עיצובים" list */
      if(!(window.PMDesigns&&window.PMDesigns.active()))designHidden(f,'properties[נוסחים לפי מוצר]',assignList(design));
    }
    if(!pmPerAddon&&f._pmShownUnits?.length)designHidden(f,'properties[_מוצרים שאושרו בהוספה לעגלה]',f._pmShownUnits.join(', '));
    /* Ran 21.10 (R2): the product line gets a hidden _pm_line id and its add-ons (and charge) a matching _parent_line, so each
       add-on stays with this line whatever the cart order (snippets/cart-item.liquid). A line with a print file is unique anyway
       (new upload), so its id is new; a line without one keeps merging with an identical add: its id comes from its properties.
       Editing a cart line on this page keeps that line's id (assets/pampas-sticker-pdp.js). */
    {
      qa('[data-pm-line]',f).forEach(x=>x.remove());
      const R=window.PMStickerReplace,fileIn=qa('input[type="file"]',f).some(x=>x.name&&!x.disabled&&x.files&&x.files.length);
      let line=R&&R.line?String(R.line):'';
      if(!line&&fileIn)line='L'+Date.now().toString(36)+Math.random().toString(36).slice(2,8);
      if(!line){const t=JSON.stringify([...new FormData(f).entries()].filter(([k,v])=>typeof v==='string'&&k.indexOf('properties[')===0).sort((a,c)=>a[0]<c[0]?-1:a[0]>c[0]?1:0));let h=5381;for(let n=0;n<t.length;n++)h=((h<<5)+h+t.charCodeAt(n))|0;line='P'+pv+'.'+(h>>>0).toString(36)}
      const li=document.createElement('input');li.type='hidden';li.name='properties[_pm_line]';li.value=line;li.dataset.pmLine='1';f.append(li);
      /* 23.10: the line whose dedication is paid by the sticker add-on says so, so the cart can put a removed sticker back */
      const SV=String((window.PMAddonMap&&window.PMAddonMap.sticker&&window.PMAddonMap.sticker.v)||'');
      const SI=SV?(items||[]).find(it=>String(it.id)===SV&&!(it.properties||{})._pm_distinct_design_charge):null;
      if(SI){const ls=document.createElement('input');ls.type='hidden';ls.name='properties[_pm_paid_by]';ls.value='sticker';ls.dataset.pmLine='1';f.append(ls);
        /* REQ-027 (Codex adversarial 3 #1): how many stickers pay for this design, so a sticker removed behind the cart comes back with its count */
        const lc=document.createElement('input');lc.type='hidden';lc.name='properties[_pm_stickers]';lc.value=String(parseInt(SI.quantity,10)||1);lc.dataset.pmLine='1';f.append(lc);}
      (items||[]).forEach(it=>{if(it&&it.properties&&it.properties._linked_to)it.properties._parent_line=line});
    }
    /* 23.10 (#14429 and a sold-out product): the product goes in first, its add-ons only after it is in the cart. A product the
       store refuses (sold out, no variant) leaves nothing behind; add-ons the store refuses take the product line out again
       (found by its _pm_line), so a design never stays in the cart without the add-on that pays for it. */
    const ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/');
    if(!pv)throw Error('המוצר לא זמין כרגע. בחרו אפשרות אחרת.');
    let sent=false,product=null,refused='';
    /* REQ-027 (Codex adversarial #2): how many of this line the cart holds before the add, so an add whose answer is lost can be
       recognised as done instead of being posted a second time by the fallback */
    const LID=String(q('input[name="properties[_pm_line]"]',f)?.value||'');
    const lineQty=async()=>{const c=await (await fetch(ROOT+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})).json();return (c.items||[]).reduce((a,i)=>a+(!(i.properties||{})._linked_to&&String((i.properties||{})._pm_line||'')===LID?i.quantity:0),0);};
    const before=LID?await lineQty().catch(()=>null):null;
    try{
      const fd=new FormData(f);
      const r=await fetch(ROOT+'cart/add.js',{method:'POST',body:fd,credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest',Accept:'application/json'}});
      if(r.ok){product=await r.json().catch(()=>({}));sent=true;}
      else{const p=await r.json().catch(()=>({}));refused=p.description||p.message||'לא הצלחנו להוסיף לעגלה. נסו שוב.';}
    }catch(e2){console.error(e2);}
    if(refused)throw Error(refused);
    if(!sent&&before!==null){const now=await lineQty().catch(()=>null);if(now!==null&&now>before){sent=true;product={};}}
    if(sent&&items&&items.length){
      const r=await fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})}).catch(()=>null);
      if(!r||!r.ok){
        const p=r?await r.json().catch(()=>({})):{};
        const line=String(q('[data-pm-line]',f)?.value||'');
        try{const c=await (await fetch(ROOT+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})).json();
          /* only what this add put in: a line without a print file shares its id with an identical earlier add (it merges), so its
             quantity goes back by the amount added; that earlier add's own add-ons stay */
          const added=Math.max(1,parseInt(q('input[name="quantity"]',f)?.value,10)||1),u={};
          (c.items||[]).forEach(i=>{const pp=i.properties||{};if(line&&!pp._linked_to&&String(pp._pm_line||'')===line)u[i.key]=Math.max(0,i.quantity-added);});
          /* REQ-027 (Codex G3 P1): the add-on request may have reached the store with its answer lost; the add-ons it put in for this
             line come out too, by the amount sent, so none stays behind under another line of the same product */
          const sent={};(items||[]).forEach(it=>{if(it&&it.id)sent[String(it.id)]=(sent[String(it.id)]||0)+(parseInt(it.quantity,10)||1);});
          (c.items||[]).forEach(i=>{const pp=i.properties||{};if(line&&pp._linked_to&&String(pp._parent_line||'')===line&&sent[String(i.variant_id)])u[i.key]=Math.max(0,i.quantity-sent[String(i.variant_id)]);});
          if(Object.keys(u).length)await fetch(ROOT+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:u})});
        }catch(e3){console.error(e3);}
        throw Error(p.description||p.message||'לא הצלחנו להוסיף את תוספות המתנה. נסו שוב.');
      }
    }
    if(sent){
      delete f.dataset.pmProcessing;if(b)b.disabled=false;atcMessage(f,'');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:product,addToCartBtn:b}}));
      document.dispatchEvent(new CustomEvent('pm:added',{detail:{product:product}}));
    }else{
      /* the background post did not answer (network): the old full-page post, product only. REQ-027 (Codex G2 #2): its add-ons are
         kept for the cart page it lands on, whose housekeeping adds them linked to this line once the line is in the cart
         (snippets/pampas-cart-gift.liquid, pmPendingAddons; dropped after 5 minutes), so no add-on goes in before its product */
      if(items&&items.length){const pl=String(q('input[name="properties[_pm_line]"]',f)?.value||'');try{sessionStorage.setItem('pmPendingAddons',JSON.stringify({t:Date.now(),line:pl,items}));}catch(e4){}}
      f.dataset.pmNative='1';f.enctype='multipart/form-data';HTMLFormElement.prototype.submit.call(f);
    }
  }catch(err){
    console.error(err);atcMessage(f,err.message||'לא הצלחנו להוסיף לעגלה. נסו שוב.');delete f.dataset.pmProcessing;if(b)b.disabled=false;
  }
},true);
})();

